// [BD Feat] Success story section JS for slider, Modal opening start

class SuccessStory extends HTMLElement {
  constructor() {
    super();

    this.tabs = this.querySelectorAll('.story__tabs-item');
    this.tabsContent = this.querySelectorAll('.story__content');

    this.medias = this.querySelectorAll('.story__media-item');

    this.tabsSliderEl = this.querySelector('.story__tabs-list');
    this.mediaSliderEl = this.querySelector('.story__media-list');

    this.modalOpeners = this.querySelectorAll('.story__read-more');
    this.modalCloseButtons = this.querySelectorAll('.story__modal-close');
  }

  connectedCallback() {
    this.init();
  }

  init() {
    import(flu.chunks.flickity).then(({
      Flickity
    }) => {
      const $this = this;

      const tabsLoop = this.checkChildWidth(this.tabsSliderEl, this.tabs);
      const mediaLoop = this.checkChildWidth(this.mediaSliderEl, this.medias);

      this.mediaSliderEl.classList.toggle('loop-disabled', !mediaLoop);
      
      this.tabsSlider = new Flickity( this.tabsSliderEl, {
        wrapAround: tabsLoop,
        cellAlign: 'left',
        contain: true,
        prevNextButtons: false,
        pageDots: false
      });

      
      this.mediaSlider = new Flickity( this.mediaSliderEl, {
        wrapAround: mediaLoop,
        contain: true,
        cellAlign: 'left',
        prevNextButtons: false,
        pageDots: false
      });

      this.tabsSlider.on( 'staticClick', function( event, pointer, cellElement, cellIndex ) {
        if (typeof cellIndex !== 'undefined') $this.setActiveTab(cellIndex);
      });

      this.mediaSlider.on( 'change', function( index ) {
        if (typeof index !== 'undefined') $this.setActiveTab(index);
      });

      this.mediaSlider.on( 'staticClick', function( event, pointer, cellElement, cellIndex ) {
        if (typeof cellIndex !== 'undefined') $this.setActiveTab(cellIndex);
      });
    });

    this.modalOpeners.forEach((modelOpener) => {
      modelOpener.addEventListener('click', () => {
        document.body.classList.add('story__modal--opened');
        document.getElementById(`Modal-${modelOpener.dataset.id}`).classList.add('open');
      });
    });

    this.modalCloseButtons.forEach((closeButton) => {
      closeButton.addEventListener('click', () => {
        document.body.classList.remove('story__modal--opened');
        document.querySelector('.story__modal.open').classList.remove('open');
      });
    });
  }

  setActiveTab(index) {
    this.tabs.forEach((tab, i) => {
      tab.classList.toggle('is-active', i === index);
    });

    this.tabsContent.forEach((content, i) => {
      content.classList.toggle('is-active', i === index);
    });

    this.medias.forEach((media, i) => {
      media.classList.toggle('is-active', i === index);
    });

    this.tabsSlider.select(index, true, false);
    this.mediaSlider.select(index, true, false);
  }

  checkChildWidth(parentElement, childElements) {
    try {
      const parentWidth = parentElement.offsetWidth;

      let totalChildWidth = 0;
      
      childElements.forEach((child, index) => {
          const childWidth = child.offsetWidth;

          const style = window.getComputedStyle(child);
          const marginRight = parseInt(style.marginRight, 10);

          if (index < childElements.length - 1) {
            totalChildWidth += childWidth + marginRight;
          } else {
            totalChildWidth += childWidth;
          }
      });

      return totalChildWidth > parentWidth;
    } catch (error) {
      console.error("An error occurred:", error);
      return false;
    }
  }
}

if (!customElements.get('success-story')) {
  customElements.define('success-story', SuccessStory);
}

// [BD Feat] Success story section JS for slider, Modal opening end